import React from "react";
import MemberList from "../Items/MemberList";
import MainBox from "../Items/MainBox";

export default function LastStep(props) {
  return (
    <MainBox>
      <MemberList
        groupName={props.states.groupName}
        memberList={props.states.memberList}
      />
      <div
        style={{
          textAlign: "justify",
          fontSize: "1.2em",
        }}
      >
        <p className="startText">
          خدا قوت... <br />
          از اینکه فعالیت هاتون رو با دقت ثبت کردید ممنونیم.
          <br />
          شما و هم گروهی هاتون میتونید تا 25 بهمن هر موقع که خواستید به این صفحه
          تو عقیقتون دسترسی داشته باشید و اگر چیزی به ذهنتون رسید که جا افتاده
          بود به گزارشتون اضافه کنید. <br />
          15 اسفند هم دکمه ثبت نهایی تو سامانه فعال میشه و باید یه سر به آخر
          گزارش بزنید و اون رو ثبت نهایی کنید.
          <br />
          برای اینکه بهتر ببینید چیکار کردید، ما این پایین براتون تعداد فعالیت
          هایی که ثبت کردید رو نمایش دادیم.
          <br />
          <br />
          بیاید با هم آرزو کنیم این تلاش هامون تونسته باشه مقدمات ظهور رو برای
          امام زمانمون فراهم کنه. <br />
          همسنگران شما در اتحادیه انجمن‌های اسلامی دانش‌آموزان
        </p>
      </div>

      <div>
        <h2 style={{ textAlign: "center" }}>
          تعداد فعالیت های ثبت شده در هر مرحله
        </h2>
        <table className="lastReportTabel">
          <thead>
            <th>مرحله</th>
            <th>تعداد</th>
          </thead>
          <tbody>
            <tr>
              <td>تشکیل گروه</td>
              <td>{props.ActivityCounts[1]}</td>
            </tr>
            <tr>
              <td>آماده سازی </td>
              <td>{props.ActivityCounts[2]}</td>
            </tr>{" "}
            <tr>
              <td> افتتاحیه</td>
              <td>{props.ActivityCounts[3]}</td>
            </tr>{" "}
            <tr>
              <td> برگزاری</td>
              <td>{props.ActivityCounts[4]}</td>
            </tr>{" "}
            <tr>
              <td>روایت کلاسی </td>
              <td>{props.ActivityCounts[5]}</td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* <AddActivity
        onClick={props.showModal}
        memberList={props.states.memberList}
        ActivityCounts={props.ActivityCounts}
      /> */}
    </MainBox>
  );
}
